import maDamagedItemBtn from '@/components/buttons'
import maNavbarCategory from '@/components/navbarCategories'
import maAddDamagedPartsBtn from '@/components/button-blue'
import maNavbarStepper from '@/components/navbarStepper'
import { INTERIOR_PROPERTY, MULTIDAMAGE } from '@/constants'
import { mapState, mapMutations, mapActions } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_DAMAGED_PART_KEY,
  WARRANTY_UPDATE_MULTIDAMAGE
} from '@/store/types'
import { cloneDeep } from 'lodash'
import generateUniqueId from '@/utils/generateUniqueId'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damagedParts',

  mixins: [flowMixin, userFlowMixin],

  data: function () {
    return {
      datadamagedParts: [],
      multidamagePieces: [],
      btnAddDamagedPartsIsDisabled: true,
      partsLoaded: false,
      multidamageListKey: generateUniqueId(),
      damageTypeToReturn: ''
    }
  },
  components: {
    maDamagedItemBtn,
    maNavbarCategory,
    maAddDamagedPartsBtn,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms',
      statedamagedItem: 'damagedItem',
      statedamagedItemKey: 'damagedItemKey',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral',
      stateIsMultidamage: 'isMultidamage',
      stateMultidamage: 'multidamage'
    }),

    flowName() {
      return this.getUserFlow
    },

    /**
     * Sets the title based on the stateDamagedItem if exists, else it gets it from the local storage
     */
    getDamagedItemLiteral() {
      const damagedItemLocalStorage = localStorage.getItem('damagedItemLiteral')
      return this.statedamagedItem
        ? String(this.statedamagedItem)
        : damagedItemLocalStorage
    },

    /**
     * Sets the damageType title based on the stateWarrantyDamageTypeLiteral if exists, else it gets it from the local storage
     */
    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral')
      return this.stateWarrantyDamageTypeLiteral
        ? String(this.stateWarrantyDamageTypeLiteral)
        : titleLocalStorage
    },

    // Get the description literal for de damagedPart for single or multi damages
    damagedItemDescriptionLiteral() {
      let descriptionLiteral = ''
      if (this.datadamagedParts != null) {
        const damagedPart = this.isMultidamage
          ? this.datadamagedParts[0]
          : this.datadamagedParts
        descriptionLiteral = damagedPart?.self_care_literal
        if (this.isMultidamage) {
          descriptionLiteral
            ? damagedPart.self_care_literal
            : this.$t('damagedParts.defaultText')
        } else {
          descriptionLiteral
            ? damagedPart.self_care_literal
            : this.$t('damagedParts.defaultTextExternalDamage')
        }
      }
      return descriptionLiteral
    },

    /**
     * Sets the button types
     */
    typeButton() {
      if ((this.datadamagedParts?.self_care_multi_selection) || this.isMultidamage) {
        return 'input-multiSelect-txt'
      } else if (
        this.datadamagedParts &&
        this.datadamagedParts.type === 'imgRadio'
      ) {
        return this.datadamagedParts.type
      } else {
        return 'input-txt'
      }
    },

    isMultidamage() {
      return this.stateIsMultidamage
    },

    /**
     * Returns the class name based on the button type
     */
    getBtnClass() {
      return this.datadamagedParts && this.datadamagedParts.type === 'imgRadio'
        ? 'imgRadio-btn'
        : 'txtButton'
    },

    /**
     * Based on the route category processes and returns the title
     */
    titleCategory() {
      const category = this.getDamageType
      const title = category.replace('_', ' ').replace('_', ' ').toLowerCase()
      return title
    },

    /**
     * Based on the number of objects in the report state returns the number of damaged parts selected
     */
    totalDamages() {
      return this.btnAddDamagedPartsIsDisabled
        ? 0
        : this.stateWarrantyReport.length
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyUpdateSelectedDamagedParts:
        WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS,
      mutWarrantyClearSelectedDamagedParts:
        WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateDamagedPartKey: WARRANTY_UPDATE_DAMAGED_PART_KEY,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    isBtnDisabled() {
      let disable = false
      this.multidamagePieces.forEach((element) => {
        element.pieces.forEach((piece) => {
          if (!piece.damagedParts) disable = true
          if (piece.damagedParts && piece.damagedParts.length === 0) {
            disable = true
          }
        })
      })
      this.btnAddDamagedPartsIsDisabled = disable
    },

    handleOnClickPrevRoute() {
      if (this.isMultidamage) {
        this.updateMultidamageState()
        this.routeToDamagedItems()
      } else {
        const damagedItemsViewName = 'damaged-items'
        let propertyType = this.getPropertyType
        if (this.damageTypeToReturn) {
          this.goToView(damagedItemsViewName, {
            propertyType,
            damageType: this.damageTypeToReturn
          })
        } else {
          this.goToView('damages-view')
        }
      }
    },

    updateMultidamageState() {
      const multiDamage = {
        propertyType: this.getPropertyType,
        assets: INTERIOR_PROPERTY,
        damages: this.multidamagePieces
      }

      this.mutWarrantyUpdateMultidamage(multiDamage)
    },

    routeToDamagedItems() {
      const damagedItemsViewName = 'damaged-items'
      const propertyType = this.getPropertyType
      this.goToView(damagedItemsViewName, {
        propertyType,
        damageType: INTERIOR_PROPERTY
      })
    },

    /**
     * Updates the report state objects with the damaged part key,value enables button-addDamaged-parts
     */
    handleClickdamagedPart(damagedPart, literal) {
      if (this.stateWarrantyReport.length <= 0) {
        this.addReportDefaultProperties()
      }
      this.mutWarrantyUpdateSelectedDamagedParts({ literal, damagedPart })
      this.btnAddDamagedPartsIsDisabled = false
      let value = damagedPart
      let key = this.datadamagedParts.name
      this.mutWarrantyUpdateDamagedPartKey(key)
      if (damagedPart !== 'RECHERCHE_FUITE_NETTOYAGE_TYPE') {
        this.mutWarrantyUpdateReport({ key, value })
      }
      if (this.typeButton === 'input-txt' || this.typeButton === 'imgRadio') {
        this.handleAddDamages()
      }
    },

    // Multidamage - Remove damagedPart if it already exists or add it if not
    handleOnClickMultidamagePart(
      damagedPiece,
      damagedPartKey,
      damagedPartLiteral
    ) {
      const damagedPart = {
        key: damagedPartKey,
        literal: damagedPartLiteral
      }

      if (damagedPiece.damagedParts != null) {
        const existingPiece = damagedPiece.damagedParts.find(
          (part) => part.key === damagedPartKey
        )
        if (existingPiece != null) {
          damagedPiece.damagedParts = damagedPiece.damagedParts.filter(
            (part) => part.key !== damagedPartKey
          )
        } else {
          damagedPiece.damagedParts.push(damagedPart)
        }
      } else {
        damagedPiece.damagedParts = [damagedPart]
      }

      this.isBtnDisabled()
    },

    /**
     * Adds default properties to the report
     */
    addReportDefaultProperties() {
      if (this.getDamageType === 'RECHERCHE_FUITE_NETTOYAGE') {
        const defaultProperties = [
          { key: 'propertyType', value: this.getPropertyType },
          { key: 'ASSETS', value: this.getDamageType }
        ]
        defaultProperties.forEach((property) => {
          const key = property.key
          const value = property.value
          this.mutWarrantyUpdateReport({ key, value })
        })
      } else {
        const damagedItemKeyLocalStorage =
          localStorage.getItem('damagedItemKey')
        const nameDamagedItem = this.statedamagedItemKey
          ? this.statedamagedItemKey
          : damagedItemKeyLocalStorage
        const defaultProperties = [
          { key: 'propertyType', value: this.getPropertyType },
          { key: 'ASSETS', value: this.getDamageType },
          { key: nameDamagedItem, value: this.getDamagedItem }
        ]
        defaultProperties.forEach((property) => {
          const key = property.key
          const value = property.value
          this.mutWarrantyUpdateReport({ key, value })
        })
      }
    },

    categoryExeptions(damagedParts) {
      if (this.getDamageType === INTERIOR_PROPERTY) {
        return this.addObjectMur(damagedParts)
      } else {
        return damagedParts
      }
    },

    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and update the data property datadamagedParts with the required forms
     */
    getForm() {
      this.mutWarrantyClearReport()
      this.addReportDefaultProperties()
      this.mutWarrantyClearForms()
      this.mutWarrantyClearSelectedDamagedParts()

      const warrantyId = this.getWarrantyId
      const report = this.stateWarrantyReport

      this.isMultidamage
        ? this.getMultidamageForm(warrantyId)
        : this.getSimpleDamageForm(report, warrantyId)
    },

    getSimpleDamageForm(report, warrantyId) {
      this.actWarrantyGetForms({ report, warrantyId }).then(() => {
        this.datadamagedParts =
          this.stateWarrantyForms[0].form.regions[0].inputs
        const reportLocalStorage = JSON.parse(localStorage.getItem('report'))
        const report =
          this.stateWarrantyReport.length > 0
            ? this.stateWarrantyReport[0]
            : reportLocalStorage[0]
        Object.keys(report).forEach((key) => {
          this.datadamagedParts = this.datadamagedParts.filter((input) => {
            return input.name !== key && input.type !== 'hidden'
          })
        })

        this.datadamagedParts = this.datadamagedParts[0]
        this.damagedParts = this.categoryExeptions(this.damagedParts)
      }).catch((error) => {
        const context = {
          component: 'damagedParts',
          method: 'getSimpleDamageForm',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error getting simple damage form: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'getSimpleDamageForm'
        )
      })
    },
    processDamagedPieceForms (report, damagedPiece) {
      let damagedParts = this.stateWarrantyForms[0].form.regions[0].inputs

      Object.keys(report).forEach((key) => {
        damagedParts = damagedParts.filter((input) => {
          return input.name !== key && input.type !== 'hidden'
        })
      })
      damagedPiece.form = this.categoryExeptions(damagedParts[0]).options
      damagedPiece.id = generateUniqueId() // rerender component

      this.datadamagedParts = damagedParts
    },
    setMultimadageForm(report, warrantyId) {
      this.multidamagePieces.forEach((damagedKey, i) => {
        report.PIECE = damagedKey.damageKey

        this.actWarrantyGetForms({ report, warrantyId }).then(() => {
          this.datadamagedParts = null

          damagedKey.pieces.forEach((damagedPiece) => {
            this.processDamagedPieceForms(report, damagedPiece)
          })
        }).catch((error) => {
          const context = {
            component: 'damagedParts',
            method: 'getMultidamageForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error getting multidamage form for piece ${damagedKey.damageKey}: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'getMultidamageForm'
          )
        })

        this.mutWarrantyClearForms()
        if (i === this.multidamagePieces.length - 1) {
          damagedKey.id = generateUniqueId()
          this.multidamageListKey = generateUniqueId()
          this.partsLoaded = true
        }
      })
    },
    getMultidamageForm(warrantyId) {
      this.mutWarrantyClearForms()
      const report = {
        propertyType: this.getPropertyType,
        ASSETS: INTERIOR_PROPERTY
      }

      this.setMultimadageForm(report, warrantyId)
    },

    checkPartSelected(damagedPiece, partKey) {
      if (
        damagedPiece.damagedParts != null &&
        damagedPiece.damagedParts.length > 0
      ) {
        return !!damagedPiece.damagedParts.find(
          (damagedPart) => damagedPart.key === partKey
        )
      } else {
        return false
      }
    },

    /**
     * For each report object in the report state, it will call action actWarrantyGetForms to update the forms state with the coressponding form object for each report, pushes params for next route
     */
    handleAddDamages() {
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      const damagedItem = this.getDamagedItem
      const routeName = this.isMultidamage
        ? 'multidamage-list'
        : 'damage-details'

      if (this.isMultidamage) this.updateMultidamageState()

      this.goToView(routeName, { propertyType, damageType, damagedItem })
    },

    /**
     * Removes the damaged parts 1mur,2murs etc, and adds one button Murs
     */
    addObjectMur(damagedParts) {
      const MurObJ = {
        agent_icon: null,
        image: null,
        key: '1MUR',
        literal: 'Murs'
      }
      damagedParts.options = damagedParts.options.filter(
        (option) => option.key.indexOf('MUR') === -1
      )
      damagedParts.options.push(MurObJ)
      return damagedParts
    }
  },

  /**
   * Updates datadamagedParts, if the stateWarrantyForms's length is 0, it executes getForm function
   */
  async mounted() {
    this.damageTypeToReturn = this.getDamageType
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    if (this.isMultidamage) {
      this.multidamagePieces = cloneDeep(this.stateMultidamage).damages
      this.isBtnDisabled()
    } else if (this.$route.params.damagedItem === MULTIDAMAGE) {
      const damagesViewViewName = 'damages-view'
      this.goToView(damagesViewViewName)
    }

    await this.getForm()
  }
}
